const createErrorRefRegExp = error =>
  new RegExp('(^|\\b|\\s)' + error.get('text').replace(/[$()*+,./?[\\\]^{|}-]/g, '\\$&') + '($|\\b|\\s)', 'gi')

export default cursor => {
  if (!cursor) {
    return null
  }

  return {
    errorTypes: ['ref', 'alias', 'sref', 'old', 'cluster'],
    detectError: (_, error, text, callback) => {
      if ('cluster' === error.get('type')) {
        const start = error.get('position')
        const end = start + error.get('text').length + 2

        if (!(cursor.selection.end >= start && cursor.selection.end <= end)) {
          callback(start, end)
        }
      } else {
        const reg = createErrorRefRegExp(error)

        let matchArr
        while ((matchArr = reg.exec(text)) !== null) {
          const start = matchArr.index
          const end = start + matchArr[0].length
          if (!(cursor.selection.end >= start && cursor.selection.end <= end)) {
            callback(start, end)
          }
        }
      }
    }
  }
}
